// Legend bar above the Calendar week grid: "Calendar" title + adherence color
// key (on target / off 10–25% / off >25% / not logged) + day-type/photo/period
// icons. Design reference: dark card, title left, colored legend items right.

import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import SvgIcon from "../../../../../parts/SvgIcon";
import { translateCalendarLegend, ADH_COLOR } from "./viewTokens";

const DUMBBELL_ICON = "/img/dumbbell.svg";
const CAMERA_ICON = "/img/svg/camera.svg";
const DROP_ICON = "/img/new-icons/drop-icon.svg";

const SWATCH_ITEMS = [
  { key: "onTarget", token: "good" },
  { key: "offSlightly", token: "warn" },
  { key: "offTarget", token: "bad" },
  { key: "notLogged", token: "none" },
];

// A legend entry is either a color swatch (adherence key) or an icon
// (workout/photo/period) — same label+color layout either way, so one
// component covers both instead of two near-identical ones.
const LegendItem = ({ icon, label, color }) => (
  <span className="np-cal-legend__item" style={{ color }}>
    {icon ? (
      <SvgIcon src={icon} useCurrentColor classNames="np-cal-legend__icon" />
    ) : (
      <span className="np-cal-legend__swatch" style={{ background: color }} />
    )}
    {label}
  </span>
);

LegendItem.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

export const CalendarLegend = () => {
  const { t } = useTranslation("athlete-portal");

  return (
    <div className="np-cal-legend">
      <span className="np-cal-legend__title">
        {t("nutritionPage.progress.viewSwitch.calendar")}
      </span>
      <div className="np-cal-legend__items">
        {SWATCH_ITEMS.map(({ key, token }) => (
          <LegendItem key={key} label={translateCalendarLegend(t, key)} color={ADH_COLOR[token].text} />
        ))}
        <LegendItem icon={DUMBBELL_ICON} label={translateCalendarLegend(t, "workout")} color="var(--gradient-right)" />
        <LegendItem icon={CAMERA_ICON} label={translateCalendarLegend(t, "photo")} color="var(--sleep)" />
        <LegendItem icon={DROP_ICON} label={translateCalendarLegend(t, "period")} color="var(--sore)" />
      </div>
    </div>
  );
};

export default CalendarLegend;
